import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface ElectricLinesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ElectricLines: React.FC<ElectricLinesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [electricLines, set_electricLines] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Utilities']?.['Electric Lines'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Utilities': { ...b.values?.['Utilities'], 'Electric Lines': v } } })
    );
    const label = 'Electric Lines';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(electricLines)}
                />
            ) : (
                <MoneyBox
                    id={'electricLines'}
                    allowNegative={false}
                    value={electricLines}
                    onChange={(value) => set_electricLines(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
